import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: 'Nunito, sans-serif',
  },
  palette: {
    // 50 / 100: light tints (main mixed with white at ~8% / ~16%) for
    // selected / status backgrounds such as sx bgcolor 'primary.50'
    primary: {
      main: '#2F527A',
      contrastText: '#FFFFFF',
      50: '#EEF1F4',
      100: '#DEE3EA',
    },
    secondary: {
      main: '#ca589e',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#F97316',
      50: '#FFF4EC',
      100: '#FEE9DA',
    },
    error: {
      main: '#EF4444',
      50: '#FEF0F0',
      100: '#FCE1E1',
    },
    info: {
      main: '#737ed8',
      50: '#F4F5FC',
      100: '#E9EAF9',
    }, //85de73ff
    success: {
      main: '#29db36',
      contrastText: '#FFFFFF',
      50: '#EEFCEF',
      100: '#DDF9DF',
    },
    text: {
      disabled: 'rgba(0,0,0,0.65)',
      primary: 'rgba(0, 0, 0, 0.95)',
    },
    collection: {
      due: '#3E8ACC',
      overdue: '#DB524B',
      collected: '#7AD300',
      outstanding: '#FF9D4B',
      txtcolor: '#ffffff',
      iconcolor: '#ffffff',
    },
    yellow: {
      main: '#d1900a',
      contrastText: '#FFFFFF',
    }
  },
});
